<template>
  <div class="jc-traffic-container"
       v-loading="loading">
    <permission @permissionHandle="permissionHandle"></permission>
    <div class="jc-page-top"
         v-if="permission">
      <div class="jc-page-header">
        <h1>
          <i class="jc-icon-my-circle-bold"></i>{{$t('bwTraffic.traffic')}}
        </h1>
        <div class="jc-box-action">
          <a v-bind:href="Config.BANDWIDTHTRAFFIC_SERVER_URL"
             target="_blank">{{$t('bandWidth.helpDoc',[$t('bwTraffic.traffic')])}}</a>
        </div>
      </div>
      <div class="jc-page-content">
        <div class="el-container-table common-table-container">
          <div class="el-container-table-actionBar">
            <el-form class="el-box-table-search"
                     :inline="true"
                     @submit.native.prevent>
              <el-form-item class="set-icon">
                <el-input :placeholder="$t('bandWidth.inputName')"
                          v-model="searchValue"
                          @keyup.enter.native="handleWithFliter(false)"
                          class="my-input" clearable @clear="handleWithFliter(false)">
                  <el-button slot="append"
                             @click="handleWithFliter(false)"
                             icon="el-icon-search"
                             class="search-icon"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item class="set-icon">
                <el-button icon="el-icon-setting"
                           class="jc-button-icon"
                           @click="setCustom"
                           :title="$t('merge.customList')"></el-button>
              </el-form-item>
              <el-form-item>
                <el-button icon="jc-icon-download"
                           class="jc-button-icon"
                           @click="exportList"
                           :title="$t('speechcraft.exportResourceList')"></el-button>
              </el-form-item>
            </el-form>
            <el-form class="el-table-actionBar-item"
                     :inline="true">
              <el-form-item>
                <el-button icon="jc-icon-refresh-line"
                           class="jc-button-icon"
                           @click="handleWithFliter(false)"
                           ></el-button>
              </el-form-item>
              <el-form-item>
                  <!-- <el-select v-model="selectedRoom" @change="selectedRoomChange" :placeholder="$t('placeholder.choose')">
                    <el-option
                      v-for="room in fliter_region"
                      :key="room.id"
                      :value="room.id"
                      :label="room.name">
                    </el-option>
                  </el-select> -->
                  <el-select v-model="selectTitle" @change="titleChange" clearable :placeholder="$t('placeholder.choose')">
                    <!-- <el-option
                      :key="AllId"
                      :value="AllId"
                      :label="$t('ticket.complete')">
                    </el-option> -->
                    <el-option
                      v-for="title in searchTitleArray"
                      :key="title.id"
                      :value="title.id"
                      :label="title.name">
                    </el-option>
                  </el-select>
                  <!-- 节点 -->
                  <el-select v-model="selectedRoom" @change="selectedRoomChange" :placeholder="$t('placeholder.choose')" v-if="selectTitle === 2">
                    <!-- 全部 -->
                    <el-option
                      :key="AllId"
                      :value="AllId"
                      :label="$t('ticket.complete')">
                    </el-option>
                    <el-option
                      v-for="room in fliter_region"
                      :key="room.regionEn"
                      :value="room.regionEn"
                      :label="room.regionShow">
                    </el-option>
                  </el-select>
                  <!-- 机房名称 -->
                  <el-select v-model="selectedRoom" @change="selectedRoomChange" :placeholder="$t('placeholder.choose')" v-if="selectTitle === 1">
                    <el-option
                      :key="AllId"
                      :value="AllId"
                      :label="$t('ticket.complete')">
                    </el-option>
                    <el-option
                      v-for="roomName in fliter_region"
                      :key="roomName.datacenterNameParam"
                      :value="roomName.datacenterNameParam"
                      :label="roomName.datacenterNameShow">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-form>
          </div>
          <!-- 表格 -->
          <div class="el-container-table">
            <el-table :data="trafficList"
                      v-loading="refreshloading"
                      :empty-text="tableEmptyTip"
                      @filter-change="changeFilter">
              <!-- 带宽名称 -->
              <el-table-column key="bandwidthName"
                               prop="bandwidthName"
                               :label="$t('bwTraffic.name')"
                               v-if="getCustomInfoSelect('bandwidthName')">
                <template slot-scope="scope">
                  <a href="javascript:void(0)"
                     @click="showTrafficDetail(scope.row)">
                    {{scope.row.bandwidthName | maybeEmpty}}
                  </a>
                </template>
              </el-table-column>
              <!-- 机房名称 -->
              <el-table-column prop="datacenterNameShow"
                key="datacenterNameShow"
                :label="$t('cabinet.roomName')"
                v-if="getCustomInfoSelect('datacenterNameShow')">
              </el-table-column>
              <!-- 节点 -->
              <el-table-column prop="regionShow"
                key="regionShow"
                :label="$t('idcs.region')"
                v-if="getCustomInfoSelect('regionShow')">
              </el-table-column>
              <!-- 总上行实时流量 -->
              <el-table-column key="totalTrafficIn"
                               prop="totalTrafficIn"
                               :label="$t('bwTraffic.totalUpRealTraffic')"
                               v-if="getCustomInfoSelect('totalTrafficOut')">
                <template slot-scope="scope">
                  <span>{{scope.row.totalTrafficIn | falseData}}</span>
                </template>
              </el-table-column>
              <!-- 总下行实时流量 -->
              <el-table-column key="totalTrafficOut"
                               prop="totalTrafficOut"
                               :label="$t('bwTraffic.totalDownRealTraffic')"
                               v-if="getCustomInfoSelect('totalTrafficIn')">
                <template slot-scope="scope">
                  <span>{{scope.row.totalTrafficOut | falseData}}</span>
                </template>
              </el-table-column>
              <!-- 总带宽 -->
              <el-table-column key="physicalBandwidth"
                               prop="physicalBandwidth"
                               :label="$t('bwTraffic.totalBandwidth')"
                               v-if="getCustomInfoSelect('physicalBandwidth')">
                <template slot-scope="scope">
                  <span>{{scope.row.physicalBandwidth | falseData}}</span>
                </template>
              </el-table-column>
              <!-- 操作 -->
              <el-table-column key="operate"
                               :label="$t('text.operate')"
                               v-if="getCustomInfoSelect('operation')">
                <template slot-scope="scope">
                  <el-button type="text"
                             @click="showMonitorGraph(scope.row)">
                    {{ $t('bwTraffic.controlChart') }}</el-button>
                  <el-button type="text"
                             @click="showAlertRules(scope.row)">
                    {{ $t('alarmHistory.alarmRule') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar"
         v-if="trafficList.length && permission">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalItems">
      </el-pagination>
    </div>
    <custom :visible.sync="customVisible"
            v-if="customVisible && permission"
            :optionArr="optionArr"
            :type="type"></custom>
  </div>
</template>
<script>
import custom from '../common/custom/Custom.vue';
import permission from './opt/Permission';
import { AllId} from '@/utils/common/index';
import customInfoSelect from '@/mixins/customInfoSelect';

const type = 'bandwidthTraffic';

export default {
  name: 'BandwidthTraffic',
  components: { custom, permission },
  mixins: [customInfoSelect],
  data () {
    return {
      type,
      permission: false,
      loading: true,
      searchValue: '',
      searchKey: 'bandwidthName',
      customVisible: false,
      currentPage: 1,
      pageSize: 20,
      pageSizes: [20, 50, 100],
      totalItems: 0,
      idcsList: [],
      // selectedRoom: AllId,
      selectedRoom: '', // 初始化选择"全部"
      selectTitle: 1, // 默认选择机房名称
      searchTitleArray: [
        { id: 1, name: this.$t('cabinet.roomName') }, // 机房名称
        { id: 2, name: this.$t('idcs.region') }  // 节点
      ],

      refreshloading: false,
      tableEmptyTip: '',
      trafficList: [],
      optionArr: [
        { label: this.$t('bwTraffic.name'), value: 'bandwidthName' },
        {
          // 机房名称
          label: this.$t('cabinet.roomName'),
          value: 'datacenterNameShow'
        },
        {
          // 机房名称
          label: this.$t('idcs.region'),
          value: 'regionShow'
        },
        { label: this.$t('bwTraffic.totalUpRealTraffic'), value: 'totalTrafficOut' },
        { label: this.$t('bwTraffic.totalDownRealTraffic'), value: 'totalTrafficIn' },
        { label: this.$t('bwTraffic.totalBandwidth'), value: 'physicalBandwidth' },
        { label: this.$t('text.operate'), value: 'operation' }
      ]
    };
  },
  created () { },
  mounted () { },
  filters: {
    falseData (value) {
      if (value === '') return '--';
      return `${value}Mbps`;
    }
  },
  computed: {
    // 格式化机房数据
    fliter_region () {
      if (!this.idcsList.length) return [];
      const idcsArray = [];
      this.idcsList.forEach((element) => {
        idcsArray.push({
          // id: element.idc,
          // name: element.idcName,
          // data: element,

          datacenterNameParam: element.datacenterNameParam,
          datacenterNameShow: element.datacenterNameShow,
          regionEn: element.regionEn,
          regionShow: element.regionShow
        });
      });
      return idcsArray;
    },

    // vuex中获取自定义信息
    customInfo () {
      return this.$store.state.customInfo[this.type];
    }
  },
  methods: {
    // 判断权限
    async permissionHandle (per) {
      this.loading = false;
      this.permission = per;
      if (!this.permission) return; // 没有权限返回
      if (this.$store.state.customInfo[this.type] === null) {
        this.getCustomInfo();
      }
      const res = await this.$api.getComputerRoom({ all: 1, idcLine: this.GLOBAL.IDCLINE });
      this.idcsList = res.data.idcs;
      if (!this.idcsList.length) return [];
      this.$nextTick(() => {
        // this.selectedRoom = this.idcsList[0].idc;
        // this.selectedRoom = AllId
        this.listBandwidthTraffics();
      })
    },

    // 获取机房列表
    getComputerRoom () {
      this.$api.getComputerRoom({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          this.idcsList = res.data.idcs;
          if (!this.idcsList.length) return [];
          this.selectedRoom = this.idcsList[0].idc;
          return this.idcsList;
        }
      });
    },

    // 获取自定义信息
    getCustomInfo () {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((res) => {
        if (res.errno === 10000 && res.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: res.data.customInfo, type: this.type });
        }
      });
    },
    // 标题切换
    titleChange () {
      this.selectedRoom = AllId; // 重置选择
      this.currentPage = 1;
      this.listBandwidthTraffics();
    },


    // 切换机房
    selectedRoomChange (idcId) {
      this.currentPage = 1;

      // 清空搜索條件
      this.searchValue = '';
      this.listBandwidthTraffics();
    },

    // 带宽流量详情
    showTrafficDetail (row) {
      const routeData = this.$router.resolve({
        path: `/bandwidthtraffic/detail/${row.bandwidthId}`,
        // query: { bandwidthName: row.bandwidthName, tabName: 'resource', idcId: this.selectedRoom }
        query: { bandwidthName: row.bandwidthName, tabName: 'resource', idcId: row.regionEn }
      });
      window.open(routeData.href, '_blank');
    },

    // 获取带宽流量列表
    listBandwidthTraffics (params) {
      const tempParams = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        // idc: this.selectedRoom
      };
      if (this.selectTitle === 1 && this.selectedRoom && this.selectedRoom != 'all') {
        tempParams['datacenterName'] = this.selectedRoom;
      }
      if (this.selectTitle === 2 && this.selectedRoom && this.selectedRoom != 'all') {
        tempParams['regionEn'] = this.selectedRoom;
      }
      this.refreshloading = true;
      const newParams = params || tempParams;
      this.$api.listBandwidthTraffics(newParams).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK' && res.data) {
          this.trafficList = res.data.bandwidthTraffics;
          this.totalItems = res.data.totalCount;
        }
      }).catch(() => {
        this.trafficList = [];
      }).finally(() => {
        this.refreshloading = false;
      });
    },

    // 根据筛选结果导出
    exportList () {
      let url = `/ccs-api/api/monitor/exportBandwidthTraffics?all=1`;
      if (this.searchValue !== '') {
        url += `&${this.searchKey}=${this.searchValue.trim()}`;
      }
      if (this.selectedRoom !== AllId) {
        if (this.selectTitle === 1) {
          url += `&datacenterName=${this.selectedRoom}`;
        }
        if (this.selectTitle === 2) {
          url += `&regionEn=${this.selectedRoom}`;
        }
      }
      console.log(url);
      window.open(url, '_self');
    },

    // 列表自定义
    setCustom () {
      this.customVisible = true;
    },

    // 根据搜索条件刷新列表 pageHold true 页数不置1
    handleWithFliter (pageHold) {
      if (!pageHold) this.currentPage = 1;
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        idc: this.selectedRoom
      };
      // 是否有搜索條件
      if (this.searchValue.trim() !== '') {
        params.bandwidthName = this.searchValue.trim();
      }
      this.listBandwidthTraffics(params);
    },

    // 跳转监控图
    showMonitorGraph (row) {
      this.$router.push({
        path: `/bandwidthtraffic/detail/${row.bandwidthId}`,
        // query: { bandwidthName: row.bandwidthName, tabName: 'monitor', idcId: this.selectedRoom }
        query: { bandwidthName: row.bandwidthName, tabName: 'monitor', idcId: row.regionEn }
      });
    },

    // 跳转报警规则
    showAlertRules (row) {
      this.$router.push({
        path: `/bandwidthtraffic/detail/${row.bandwidthId}`,
        // query: { bandwidthName: row.bandwidthName, tabName: 'alarmRules', idcId: this.selectedRoom }
        query: { bandwidthName: row.bandwidthName, tabName: 'alarmRules', idcId: row.regionEn }
      });
    },

    changeFilter () {

    },

    handleSizeChange (val) {
      this.pageSize = val;
      // 不对页数做操作
      this.handleWithFliter(true);
    },

    handleCurrentChange (val) {
      this.currentPage = val;
      // 不对页数做操作
      this.handleWithFliter(true);
    }
  }
};
</script>
<style lang="scss" scoped>
.jc-traffic-container {
  // 设置footer分页(勿动)
  background-color: #f6fafd;
  height: 100%;
  overflow: auto;

  // 修改机房btn颜色
  .el-table-actionBar-item /deep/ .el-radio-group {
    .el-radio-button.is-active .el-radio-button__inner {
      background: #96a0bd !important;
      color: #fff;
      border-color: #dde5ea;
      left: 0;
    }
  }
  .el-table-actionBar-item
    /deep/
    .el-radio-button__orig-radio:checked
    + .el-radio-button__inner {
    background: #96a0bd !important;
  }
  // 调tool-bar
  .el-container-table-actionBar {
    border-bottom: none !important;
  }
  .el-box-table-search /deep/ .el-input-group__append {
    border-radius: 0 3px 3px 0 !important;
  }
  .el-box-table-search /deep/ button.el-button.el-button--default.search-icon {
    border-left-width: 0px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  // .el-box-table-search /deep/ i.el-icon-search {
  //   color: #d1d9de;
  // }
}
.el-traffic-container /deep/ .custom-container .el-dialog.el-dialog--small {
  width: 500px;
}
.el-traffic-container /deep/ .el-table__body-wrapper {
  overflow: hidden;
}
.el-box-table-search{
  float: right;
}
.el-table-actionBar-item{
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/bandwidthTraffic/TrafficList.vue